import { immerable } from "immer";
import { IMultiSelectFilterItem } from "components/filters/MultiSelectFilter";

export class ClusterStore implements IMultiSelectFilterItem {
    [immerable] = true;

    private _isSelected: boolean;
    public readonly id: number;
    public readonly name: string;
    public readonly costAsPercentageOfRevenue: number;
    public readonly costValue: number;
    public readonly variance: number;
    public readonly similarityScore: number;
    constructor(
        id: number,
        isSelected: boolean,
        name: string,
        costAsPercentageOfRevenue: number,
        costValue: number,
        variance: number,
        similarityScore: number
    ) {
        this.id = id;
        this.name = name;
        this.costAsPercentageOfRevenue = costAsPercentageOfRevenue;
        this.costValue = costValue;
        this.variance = variance;
        this.similarityScore = similarityScore;
        this._isSelected = isSelected;
    }

    isSelected() {
        return this._isSelected;
    }

    setIsSelected(isSelected: boolean) {
        this._isSelected = isSelected;
    }

    toggleIsSelected() {
        this._isSelected = !this._isSelected;
    }
}
